<template>
    <div>
        <announcement-component  :key="object_id" :user="user" :sepaInfoMissing="sepaInfoMissing"  />
        <inserat-ueberblick-component />
        <object-filter-component      />
        <div v-if="objects && objects.length > 0 && numOfPages > 0">
            <object-component v-for="object in objects"
                             :key="object.id"
                             :object="object"
                             :sepaInfoMissing="sepaInfoMissing"
                             @openModal="openModal"
                             @hervorheben="hervorheben"
                             @error="objectError"
                             @warning="objectWarning"
                             @success="objectSuccess"/>
            <pagination-component :numOfPages="numOfPages" routePath="inserat-uebersicht" :page="page"/>
        </div>
        <div v-else class="alert alert-warning">
            Es konnte kein Inserat mit den gewählten Sucheinstellungen gefunden werden.
        </div>
        <b-toast id="error-toast" title="Fehlermeldung" variant="danger" solid>
            {{error}}
        </b-toast>
        <b-toast id="success-toast" variant="success" solid>
            {{success}}
        </b-toast>
        <b-toast id="warning-toast" title="Warnung" variant="warning" solid>
            {{warning}}
        </b-toast>
        <!-- Daten übernehmen Modal -->
        <b-modal ref="modal" :title="$t('intern_presets.title')" :size="'lg'">
            <div class="d-block">
                <p>{{$t('intern_presets.description')}}</p>
                <p>{{$t('intern_presets.choose')}}</p>
                <p>
                    <single-select
                        v-if="tinyObjects"
                        v-model="presets.selectedObject"
                        :list="tinyObjects.filter(item => item.id != presets.currentObject)"
                        placeholder="Inseratstitel / Inseratsnummer"
                        :shownAttribute="['id', 'name']"
                        @select="changePreviewUrl"
                    />
                    <a v-if="presets.selectedObject != ''" :href="presets.preview" target="_blank" class="mm-link">Vorschau</a>
                </p>
                <div class="mt-5">
                    <div class="form-group">
                        <label>
                            <input type="checkbox" v-model="presets.rental_conditions"> Mietbedingungen übernehmen
                        </label>
                    </div>
                    <div class="form-group">
                        <label>
                            <input type="checkbox" v-model="presets.location"> Standorte übernehmen
                        </label>
                    </div>
                    <div class="form-group">
                        <label>
                            <input type="checkbox" v-model="presets.contact"> Kontaktdaten übernehmen
                        </label>
                    </div>
                </div>
                <hr>
                <div>
                    <div class="form-group" v-if="presets.available_categories.length > 0">
                        <label>
                            <input type="checkbox" v-model="presets.allCategory">
                            {{$t('intern_presets.change_category')}}
                            <select v-model="presets.category" class="form-control" style="display: inline-block; width: 170px;">
                                <option value="">Kategorie</option>
                                <option v-for="category in presets.available_categories" :key="category.id" :value="category.id">
                                    {{category.name}}
                                </option>
                            </select>
                            übernehmen
                        </label>
                    </div>
                    <div class="form-group">
                        <label>
                            <input type="checkbox" v-model="presets.all"> {{$t('intern_presets.change_all')}}
                        </label>
                    </div>
                </div>
            </div>
            <template slot="modal-footer">
                <b-button variant="secondary" @click="clearModal">Schließen</b-button>
                <b-button variant="success"
                          @click="confirmClonePresets"
                          :disabled="presets.selectedObject == '' || (presets.allCategory && presets.category == '' && ! presets.all)">Speichern</b-button>
            </template>
        </b-modal>
        <!-- Inserat hervorheben modal -->
        <b-modal ref="hervorheben-modal" :title="'Aufwertungen'" :size="'lg'" :hide-footer="true" @hide="selectedObject = null">
            <div class="d-block">
                <improvement-component
                    :pop_up="true"
                    :object="selectedObject"
                    @close="$refs['hervorheben-modal'].hide()">
                </improvement-component>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import ObjectComponent             from '../../components/object/Object'
    import AnnouncementComponent       from '../../components/object/Announcement'
    import InseratUeberblickComponent  from '../../components/object/InseratUeberblick'
    import ObjectFilterComponent       from '../../components/object/ObjectFilter'
    import ImprovementComponent        from '../../components/object/booking/ImprovementTab';
    import PaginationComponent         from '../../components/shared/Pagination';

    export default {
        name: 'inserat-uebersicht',
        data() {
            return {
                selectedObject: null,
                user: this.$store.state.user,
                objects: this.$store.getters.objects,
                numOfPages: this.$store.getters.numOfPages,
                error: '',
                warning: '',
                success: '',
                tinyObjects: null,
                object_id : null,
                sepaInfoMissing : this.$store.state.sepaInfoMissing,
                opened_invoices: [],
                presets: {
                    currentObject: null,
                    preview: '',
                    selectedObject: '',
                    available_categories: [],
                    rental_conditions: true,
                    location: true,
                    contact: true,
                    allCategory: false,
                    category: '',
                    all: false
                }
            }
        },
        watch: {
            page: function(val) {
                this.$store.dispatch('OBJECTS', val);
            },
        },
        props: ['page'],
        components: {
            ObjectComponent,
            ObjectFilterComponent,
            AnnouncementComponent,
            InseratUeberblickComponent,
            ImprovementComponent,
            PaginationComponent
        },
        methods: {
            scrollTop() {
                window.scrollTo(0, 0);
            },
            openModal(id) {
                this.presets.currentObject = id;
                this.$refs.modal.show();
            },
            clearModal() {
                this.$refs.modal.hide();
                this.presets = {
                    currentObject: null,
                    preview: '',
                    selectedObject: '',
                    available_categories: this.presets.available_categories,
                    rental_conditions: true,
                    location: true,
                    contact: true,
                    allCategory: false,
                    category: '',
                    all: false
                }
            },
            confirmClonePresets() {
                if(this.presets.allCategory || this.presets.all){
                    this.$bvModal.msgBoxConfirm('Bitte bestätigen', {
                        title: 'Bestätigung',
                        okVariant: 'success',
                        cancelTitle: 'Nein',
                        okTitle: 'Ja'
                    }).then( confirmation => {
                        confirmation ? this.clonePresets() : false;
                    }).catch( error => {console.log(error);})
                }else {
                    this.clonePresets();
                }
            },
            clonePresets() {
                let data = {
                    to:         this.presets.currentObject,
                    from:       this.presets.selectedObject,
                    to_all:     this.presets.all,
                    category:   this.presets.category,
                    to_all_of_category:  this.presets.allCategory,
                    data_to_be_transferred:  {
                        contact:  this.presets.contact,
                        location: this.presets.location,
                        rental_conditions: this.presets.rental_conditions,
                    },
                };
                this.$store.state.loading = true;
                this.$http.put('objectApi/transferData', data).then( response => {
                    this.$store.state.loading = false;
                    this.objectSuccess(response.data, false);
                    this.clearModal();
                }).catch( error => {
                    this.objectError(error.response.data.data);
                    this.$store.state.loading = false;
                });
            },
            changePreviewUrl() {
                this.presets.preview = this.tinyObjects.find( obj => obj.id == this.presets.selectedObject ).url;
            },
            objectError(error) {
                this.error = error;
                this.$bvToast.show('error-toast');
            },
            objectWarning(warning) {
                this.warning = warning;
                this.$bvToast.show('warning-toast');
            },
            objectSuccess(success, dispatch = true) {
                this.success = success;
                this.$bvToast.show('success-toast');
                if(dispatch){
                    this.$store.dispatch('OBJECTS', this.page);
                    this.$store.dispatch('NOTIFICATIONS_COUNT');
                }
            },
            hervorheben(object) {
                this.selectedObject = object;
                this.$refs['hervorheben-modal'].show();
            },
            sepaInfoMissingAlert(invoiceID){
                let h = this.$createElement;
                let msgNode = h('div', { domProps: {innerHTML: this.$t('intern_paymentdata.nosepa_info_dialog_text')}});

                this.$bvModal.msgBoxConfirm([msgNode], {
                        okVariant: 'success',
                        cancelVariant: 'secondary',
                        okTitle: 'Zur Eingabe der Bankdaten',
                        cancelTitle: 'Schließen'
                }).then(val => {
                      if (val) {
                          location.href  = '/intern/rechnung/bezahlen/' + invoiceID;
                      }
                });
            }
        },
        created() {
              this.scrollTop();
              document.title = 'Übersicht meiner Inserate';

              let filters          = this.$store.state.availableFilters;
              let tinyObjects      = this.$store.state.tinyObjects;

              if(filters != null){
                  this.presets.available_categories = filters.categoryList;
              }

              this.tinyObjects = tinyObjects.all;

              this.$store.dispatch('ASSESSMENT_COUNT');
              this.$store.dispatch('NOTIFICATIONS_COUNT');
              this.$store.dispatch('AVAILABLE_FILTERS');
              this.$store.dispatch('OBJECTS', this.page);
              this.$store.dispatch('LOGIN_USER');

              if(!this.$store.state.object_packets){
                  this.$store.dispatch('OBJECT_PACKETS');
              }

              this.$store.watch(() => {
                  return this.$store.getters.objects;
              }, objects => {
                  this.objects = objects;
              });

              this.$store.watch(() => {
                  return this.$store.getters.numOfPages;
              }, numOfPages => {
                  this.numOfPages = numOfPages;
              });

              this.$store.watch(() => {
                  return this.$store.getters.tinyObjects.all;
              }, all => {
                  this.tinyObjects = all;
              });

              this.$store.watch(() => {
                  return this.$store.getters.availableFilters;
              }, availableFilters => {
                  this.presets.available_categories   = availableFilters.categoryList;
              });

              this.$store.watch(() => {
                  return this.$store.getters.user;
              }, user => {
                  this.user = user;
              });

              this.$store.watch(() => {
                  return this.$store.getters.sepaInfoMissing;
              }, sepaInfoMissing => {
                  this.sepaInfoMissing = sepaInfoMissing;
                  if (this.sepaInfoMissing && this.user && this.user.packet && this.user.packet.type == 'custom') {
                    this.$http.get('invoiceApi/getOpenedInvoice').then(response => {
                      this.opened_invoices = JSON.parse(response.data);
                      if(this.opened_invoices.length > 0)
                        this.sepaInfoMissingAlert(this.opened_invoices[0].id);
                    });
                  }
              });
        },
    }
</script>

<style scoped>
.page-link{
    color: #5FA963 !important;
    font-weight: 600;
}
.router-link-exact-active.router-link-active{
    background-color: rgb(206, 228, 207);
}
.arrow-first-last{
    background-color: #fff !important;
}
</style>
